module.exports = __webpack_public_path__ + "static/media/logo-white.597c6a95.svg";